export default function reorderList(arr, dragResult, orderField, excludeField) {
  const { removedIndex, addedIndex, payload } = dragResult;

  if (removedIndex === null && addedIndex === null) {
    return arr;
  }

  const excluded = excludeField ? arr.filter((item) => item[excludeField]) : [];
  const included = excludeField ? arr.filter((item) => !item[excludeField]) : [...arr];

  const result = [...included];
  let itemToAdd = payload;

  if (removedIndex !== null) {
    itemToAdd = result.splice(removedIndex, 1)?.[0];
  }

  if (addedIndex !== null) {
    result.splice(addedIndex, 0, itemToAdd);
  }

  if (orderField) {
    result.forEach((item, index) => {
      item[orderField] = index;
    });
  }

  return [...excluded, ...result];
}
